import React from "react";

const Reload = () => {
  return (
    <svg
      width="10"
      height="13"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: "luminosity" }}>
        <path
          d="M7.27344 8.97656C7.5 8.97656 7.67969 8.90625 7.82031 8.75781L11.0234 5.53125C11.1953 5.35938 11.2734 5.17188 11.2734 4.95312C11.2734 4.74219 11.1875 4.53906 11.0234 4.38281L7.82031 1.125C7.67969 0.96875 7.5 0.890625 7.27344 0.890625C6.85156 0.890625 6.51562 1.24219 6.51562 1.67188C6.51562 1.88281 6.59375 2.05469 6.72656 2.20312L8.59375 4.03125C8.22656 3.97656 7.85156 3.94531 7.47656 3.94531C3.60938 3.94531 0.515625 7.03906 0.515625 10.9141C0.515625 14.7891 3.63281 17.9062 7.5 17.9062C11.375 17.9062 14.4844 14.7891 14.4844 10.9141C14.4844 10.4453 14.1562 10.1094 13.6875 10.1094C13.2344 10.1094 12.9297 10.4453 12.9297 10.9141C12.9297 13.9297 10.5156 16.3516 7.5 16.3516C4.49219 16.3516 2.07031 13.9297 2.07031 10.9141C2.07031 7.875 4.46875 5.46875 7.47656 5.46875C7.98438 5.46875 8.45312 5.50781 8.86719 5.57812L6.73438 7.6875C6.59375 7.82812 6.51562 8 6.51562 8.21094C6.51562 8.64062 6.85156 8.97656 7.27344 8.97656Z"
          fill="#797979"
        />
      </g>
    </svg>
  );
};

export default Reload;
